import * as actions from './newReleasesActions';
import * as actionTypes from './newReleasesActionTypes';
import reducer from './newReleasesReducer';
import * as selectors from './newReleasesSelectors';

export { actions, actionTypes, reducer, selectors };
